import * as React from 'react';
import theme from './CompanionGroup.module.css';
import { Group, Option } from '../../../../../Autocomplete/types';
import { FillValue } from '../../../../../Checkout/components/Checkout/Form/types';
import { ReactNode } from 'react';

interface Props {
	companion: Group<FillValue>;
	optionRender: (option: Option<FillValue>, key: number) => ReactNode;
}

const CompanionGroup: React.FC<Props> = ({ companion, optionRender }) => {
	return (
		<div key={companion.label.toLocaleString()} className={theme.root}>
			<div className={theme.name}>{companion.label}</div>

			{companion.options.map(optionRender)}
		</div>
	);
};

export default CompanionGroup;
